"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentTypeToJSON = exports.ExperimentTypeFromJSONTyped = exports.ExperimentTypeFromJSON = exports.ExperimentType = void 0;
/**
 * The type of experiment.
 * @export
 */
exports.ExperimentType = {
    Survey: 'SURVEY',
    SurveyV2: 'SURVEY_V2',
    Unknown: 'UNKNOWN'
};
function ExperimentTypeFromJSON(json) {
    return ExperimentTypeFromJSONTyped(json, false);
}
exports.ExperimentTypeFromJSON = ExperimentTypeFromJSON;
function ExperimentTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ExperimentTypeFromJSONTyped = ExperimentTypeFromJSONTyped;
function ExperimentTypeToJSON(value) {
    return value;
}
exports.ExperimentTypeToJSON = ExperimentTypeToJSON;
